<template>
  <div class="container" id="app">
    <div class="card">
      <div class="card-body card-padding">
        <div class="head-box">
          <h4>
            当前模块保存的过滤器
          </h4>
          <div class="c-flex">
            <div class="search_input">
              <input type="text" placeholder="Search" v-model="filterSearchVal" />
              <span>搜索</span>
            </div>
          </div>
        </div>
        <div class="content">
          <div>
            <h5 class="c_p_t_0">
              <el-button
                type="text"
                icon="el-icon-arrow-left"
                class="c_size_14"
                @click="$router.go(-1)"
              >
                返回
              </el-button>
            </h5>
          </div>
          <div>
            <div>
              <h5>系统默认的</h5>
              <ul>
                <li
                  v-for="(item, i) in internalList"
                  :key="i"
                  class="filters c_flex c_flex_between c_h_blue_light c_item_center c_h_blue"
                >
                  <a href="#" @click="toQuery(item)">{{ item.name }}</a>
                </li>
              </ul>
            </div>
            <div>
              <h5>由我创建的</h5>
              <ul>
                <li
                  v-for="(item, index) in myList"
                  :key="index"
                  class="filters c_flex c_flex_between c_h_blue_light c_item_start c_h_blue"
                >
                  <a href="#" @click="toQuery(item)">{{ item.name }}</a>
                  <span>
                    <!-- <i class="el-icon-edit c_pointer c_m_r_n icon_edit" @click="toQuery(item)"></i> -->
                    <i
                      class="el-icon-delete c_pointer c_pointer icon_del"
                      @click="removeFilter(item, index, 'me')"
                    ></i>
                  </span>
                </li>
              </ul>
            </div>
            <div class="c_flex c_flex_col" v-if="false">
              <h5>由他人创建的</h5>
              <ul>
                <li
                  v-for="(item, index) in othersList"
                  :key="index"
                  class="filters c_flex c_flex_between c_h_blue_light c_item_center c_h_blue"
                >
                  <a href="#" @click="toQuery(item)">{{ item.name }}</a>
                  <span>
                    <!-- <i class="el-icon-edit c_pointer c_m_r_n icon_edit" @click="toQuery(item)"></i> -->
                    <i
                      class="el-icon-delete c_pointer c_pointer icon_del"
                      @click="removeFilter(item, index, 'others')"
                    ></i>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'filters',
  data() {
    return {
      userId: '',
      name: '',
      // 搜索内容
      contactsSearch: {
        name: '',
        page: 1,
        pages: 1
      },
      myList0: [],
      myList: [], //所有我创建的过滤器
      othersList0: [],
      othersList: [], //所有其他人创建的过滤器
      internalList: [], //系统默认过滤器
      filterSearchVal: '' //搜索
    };
  },
  mounted() {
    window.$this = this;
    this.userId = JSON.parse(sessionStorage['entity'])._id;

    this.name = this.osg.param('name');
    this.createdByMe();
    this.createdByOthers();
    this.createdByInternal();
  },
  methods: {
    toQuery(filterObj) {
      //带参数跳转到客户列表
      event.preventDefault();
      if (!filterObj) {
        //查询所有客户
        sessionStorage.removeItem('filter');
        sessionStorage.removeItem('preFilter');
      } else {
        sessionStorage['filter'] = JSON.stringify(filterObj);
      }
      sessionStorage.removeItem('preFilter');
      this.$router.go(-1);
    },
    createdByMe() {
      this.osg.ajax(
        'queryPlan/selectByTableByOne.do',
        {
          tablename: this.name
        },
        res => {
          this.myList0 = res.data;
          this.myList = res.data;
        }
      );
    },
    createdByOthers() {
      this.osg.ajax(
        'queryPlan/selectByTableByOther.do',
        {
          tablename: this.name
        },
        res => {
          this.othersList0 = res.data;
          this.othersList = res.data;
        }
      );
    },
    createdByInternal() {
      this.osg.ajax(
        'queryPlan/selectByTableByInternal.do',
        {
          tablename: this.name
        },
        res => {
          this.internalList = res.data;
        }
      );
    },
    //删除选中过滤器
    removeFilter(item, index, who) {
      this.osg.confirm('是否确认删除', () => {
        this.osg.ajax(`queryPlan/remove/${item._id}.do`, {}, () => {
          if (who == 'me') {
            this.myList.splice(index, 1);
          } else if (who == 'others') {
            this.othersList.splice(index, 1);
          }
          this.osg.toast('删除成功！');
        });
      });
    }
  },
  watch: {
    filterSearchVal() {
      var myNewList = [];
      for (let item of this.myList0) {
        if (item.name.indexOf(this.filterSearchVal) != -1) {
          myNewList.push(item);
        }
      }
      this.myList = myNewList;
      var othersNewList = [];
      for (let item of this.othersList0) {
        if (item.name.indexOf(this.filterSearchVal) != -1) {
          othersNewList.push(item);
        }
      }
      this.othersList = othersNewList;
    },
    $router(to, from) {
      console.log(to, from);
    }
  }
};
</script>
<style scoped>
@import url('../resources/css/filters.css');
.filters {
  padding: 12px;
}
.filters > span {
  width: 60px;
  text-align: right;
  margin-left: 10px;
}
.icon_edit:hover {
  color: rgb(3, 162, 228);
}
.icon_del:hover {
  color: red;
}
.c_h_blue:hover a {
  color: rgb(3, 162, 228) !important;
}
/*所有过滤器-内容*/
.content {
  display: flex;
  width: 100%;
  margin: 0;
}
.content div:first-child {
  width: 200px;
  min-height: 400px;
  border-right: 1px solid rgb(203, 214, 226);
}
.content div:last-child {
  width: 100%;
  min-height: 400px;
  display: flex;
}
.content div:last-child div {
  width: 33.3%;
  height: 100%;
  border-right: 1px solid rgb(203, 214, 226);
  display: flex;
  flex-direction: column;
}
</style>
